module.exports = __webpack_public_path__ + "static/media/aiblogo.1ada1109.png";